import React, { useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import SignIn from '../../components/signIn/SignIn';
import SignUp from '../../components/signUp/SignUp';
import useMetaMask from '../../hooks/metamask';
import './Auth.css';

const Auth = () => {
    const navigate = useNavigate();
    const { isActive } = useMetaMask();
    const userLoggedIn = useSelector((state) => state.auth.userLoggedIn);
    useEffect(() => {
        if (!userLoggedIn && !isActive) {
            navigate('/');
        }
    }, [userLoggedIn, isActive, navigate]);

    useEffect(() => {
        if (userLoggedIn) {
            navigate(-1);
        }
    }, [userLoggedIn, navigate]);

    return (
        <>
            <div className="form-tabbing">
                <Tabs defaultActiveKey="profile" id="uncontrolled-tab-example" className="">
                    <Tab eventKey="home" title="Sign Up">
                        <SignUp />
                    </Tab>
                    <Tab eventKey="profile" title="Sign In">
                        <SignIn />
                    </Tab>
                </Tabs>
            </div>
        </>
    );
};

export default Auth;
